/* eslint-disable camelcase */

const addToCart = async (variantId, qty, sellingPlan, properties = {}) => {
  const item = {
    id: variantId,
    quantity: qty,
    properties
  };

  if (sellingPlan) {
    item.selling_plan = sellingPlan;
  }

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item)
    });
    const addedItem = await response.json();
    return addedItem.key;
  } catch (err) {
    console.error('Add to cart error:', err);
  }
};

export default addToCart;
